// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "_assets/" + chunkId + "-" + "8ab6d6382fbd607db3a1" + "-ade4ba9718be3d0b2f6b26782fbeda8b1ed36057.css";
};